import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../store/authSlice';
import { isReferentePrincipale } from '../utils';
import { ReactComponent as MenuCloseIcon } from '../assets/icons/menu-close.svg';
import { ReactComponent as LogoutIcon } from '../assets/icons/logout.svg';

const Menu = ({menuOpen, toggleMenu}) => {

    const authData = useSelector(state => state.auth.authData);    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const menuItems = [
        { path: '/', label: 'Chiamate' },
        { path: '/configurazione', label: 'Configurazione', state: { op: 'edit' } },
        { path: '/listafaq', label: 'Faq' },
        { path: '/rubrica', label: 'Rubrica' },
        { path: '/referenti', label: 'Referenti', condition: () => isReferentePrincipale(authData?.user) },
        { path: '/notifiche', label: 'Notifiche' },
        { path: '/stato_servizio', label: 'Stato Servizio' }
    ];

    const isActive = (path) => location.pathname === path;

    const getItemClassName = (path) => `menu__item ${isActive(path) ? 'active' : ''}`.trim();

    const handleNavigate = (path, state) => () => {
        toggleMenu(false);
        navigate(path, {state});
    }

    const handleLogout = () => {
        // Logica per il logout, ad esempio rimuovere i dati di autenticazione
       toggleMenu(false);
       dispatch(logout());
    }

    return <nav className={`menu ${menuOpen ? 'open' : ''}`}>
                <button className="menu__close" onClick={() => toggleMenu(false)}><MenuCloseIcon/></button>
                <ul className="menu__list">
                    {menuItems.map((item, index) => {
                        // Controlla se l'item ha una condizione e se questa è soddisfatta
                        if (item.condition && !item.condition()) return null;
                        
                        return (
                            <li 
                                key={index}
                                className={getItemClassName(item.path)} 
                                onClick={handleNavigate(item.path, item.state)}
                            >
                                {item.label}
                            </li>
                        );
                    })}
                    <li className="menu__item" onClick={handleLogout}>
                        <span className="logout"><LogoutIcon/>&nbsp;Esci</span>
                    </li>
                </ul>
                <div className='menu__footer'>
                    <span className="menu__loghi"></span>
                    <p className='copyright'>© 2025 6InUfficio</p>
                </div>
            </nav>;
}

export default Menu;